import { render } from "./Podcast.vue?vue&type=template&id=2b2cc7dc"
import script from "./Podcast.vue?vue&type=script&lang=js"
export * from "./Podcast.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__